// @ts-nocheck

import { createSelector } from 'reselect';

import { type StateType } from '../../../states';
import { type Selector } from '../../../types/selectors';
import { type BoomStepState } from '../reducers/boom';
import { type BoomStepId } from '../types/steps';

import { selectBoomStepsState } from './steps/stepsPrimary.selector';
import { selectBoomStepsOrderState } from './stepsOrder/stepsOrderPrimary.selector';
import { selectBoomUserNbWonSteps } from './user.selector';

const emptyObj = {};

export const selectBoomCurrentStepId: Selector<BoomStepId> = (state: StateType) => {
  const stepsOrder = selectBoomStepsOrderState(state);
  const nbWonSteps = selectBoomUserNbWonSteps(state);

  return stepsOrder[nbWonSteps];
};

export const selectBoomCurrentStep: Selector<BoomStepState> = (state: StateType) => {
  const steps = selectBoomStepsState(state);
  const currentStepId = selectBoomCurrentStepId(state);

  return steps[currentStepId] ?? emptyObj;
};

export const selectBoomCurrentStepEligibility: Selector<unknown> = (state: StateType) =>
  selectBoomCurrentStep(state)?.eligibility ?? emptyObj;

export const selectBoomCurrentStepStakeMultiplier: Selector<number> = (state: StateType) =>
  selectBoomCurrentStep(state)?.stakeMultiplier ?? 1;

export const selectBoomCurrentStepStepId: Selector<string | undefined> = (state: StateType) =>
  selectBoomCurrentStep(state)?.stepId;

export const selectBoomOrderedSteps: Selector<Array<BoomStepState>> = createSelector(
  [selectBoomStepsState, selectBoomStepsOrderState],
  (steps, stepsOrder) => stepsOrder.map((stepId) => steps[stepId]),
);
